<template>
    <div>
        <h1 class="view-title" data-v-step-report="1">
            RELATÓRIO <span v-popover:tooltip.right="'Seção de criação de Relatórios'"><i class="fas fa-question-circle"></i></span>
        </h1>
        <div class="inner-content shadowed">
            <div v-if="view == 'form'" class="inner-content-title">
                Formulário de filtragem <span v-popover:tooltip.right="'Preenchar o formulário abaixo para gerar o relatório de status atual de carga ou roteiro gerado'"><i class="fas fa-question-circle"></i></span>
                <button class="btn btn-link btn-right" @click="$refs.tour.editTour()" style="margin-top: 10px; margin-left: 15px;" data-v-step-report="2">
                    <i class="fas fa-question-circle"></i> TOUR
                </button>
            </div>
            <div v-else class="inner-content-title inner-content-button">
                <div class="row">
                    <div class="col-xs-12 col-lg-6">
                        Exibição do relatório
                    </div>
                    <div class="col-xs-12 col-lg-6">
                        <button class="button-download" :disabled="generating" @click="download">
                            DOWNLOAD <i :class="'fa fa-fw ' + ((generating) ? 'fa-circle-notch fa-spin' : 'fa-download')"></i> 
                        </button>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12 col-lg-12">
                    <div v-if="loading" class="container-loading">
                        <div class="loading">
                            <i class="fa fa-circle-notch fa-spin"></i>
                        </div>
                    </div>
                    <div v-else-if="!loading && view == 'form'" class="container-form" data-v-step-report="3">
                        <ReportForm 
                            :fields="fields"
                            :my_cargos="my_cargos"
                            :my_drivers="my_drivers"
                            :my_vehicles="my_vehicles"
                            @update="updateFields"
                            ref="report_form"
                        />
                    </div>
                    <div v-else-if="!loading && view == 'pdf'" class="container-pdf">
                        <ReportViewPDF
                            :data="data"
                            :fields="fields"
                            @generating="setGenetating"
                            ref="report_view_pdf"
                        />
                    </div>
                </div>
                <div class="col-xs-12 col-lg-12">
                    <div class="container-button">
                        <div class="row">
                            <div v-if="view == 'form'" class="col-xs-12 col-lg-12">
                                <button class="button-edit btn-right" :disabled="loading" @click="send" data-v-step-report="4">
                                    GERAR RELATÓRIO <i :class="'fa fa-fw ' + ((loading) ? 'fa-circle-notch fa-spin' : 'fa-caret-right')"></i>
                                </button>
                            </div>
                            <div v-if="view == 'pdf'" class="col-xs-12 col-lg-6">
                                <button class="button-back" :disabled="loading" @click="back">
                                    <i :class="'fa fa-fw ' + ((loading) ? 'fa-circle-notch fa-spin' : 'fa-angle-left')"></i> VOLTAR
                                </button>
                            </div>
                            <div v-if="view == 'pdf'" class="col-xs-12 col-lg-6">
                                <button class="button-download" :disabled="generating" @click="download">
                                    DOWNLOAD <i :class="'fa fa-fw ' + ((generating) ? 'fa-circle-notch fa-spin' : 'fa-download')"></i> 
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <Tour
            tour="Report"
            :steps="tour_steps"
			:callbackOnFinish="true"
			ref="tour"
        />
    </div>
</template>

<script>
import Api from "@/lib/Api";

import ReportForm from "./Report/ReportForm.vue";
import ReportViewPDF from "./Report/ReportViewPDF.vue";
import Tour from "@/components/Tour";

export default {
    name: "Report",

    components: {
        ReportForm,
        ReportViewPDF,
        Tour,
    },

    data: function() {
        return {
            loading: false,
            view: 'form',
            data: null,
            fields: {
                //documents: [],
                drivers: [],
                license_plates: [],
                type: [],
                cargo: "",
                //date: "",
                //show_period: false,
                start_date: "",
                end_date: "",
                //start_time: "",
                //end_time: "",
                show_cargo: false,
            },
            //my_documents: [],
            my_cargos: [],
            my_drivers: [],
            my_vehicles: [],
            generating: true,
            
            tour_steps: [
                {
                    target: '[data-v-step-report="0"]',
                    header: {
                        title: '<code>SEÇÃO RELATÓRIO</code>',
                    },
                    content: '<code>Clique no menu <b>RELATÓRIO</b> para ir a seção visualização e exportação de relatórios</code>',
                    params: {
                        placement: 'right',
                        highlight: false,
                    }
                },
                {
                    target: '[data-v-step-report="1"]',
                    header: {
                        title: '<code>SEÇÃO ATUAL</code>',
                    },
                    content: '<code>Identifique pelo título a seção que está atualmente</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-report="2"]',
                    header: {
                        title: '<code>TOUR</code>',
                    },
                    content: '<code>Em caso de dúvida clique no botão <b>TOUR</b> para gerenciar a exibição do tour nessa seção, e assim ter um auxílio referente aos elementos da página</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-report="3"]',
                    header: {
                        title: '<code>FORMULÁRIO</code>',
                    },
                    content: '<code>Preencha os campos fundamentais para o processamento do relatório</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-report="4"]',
                    header: {
                        title: '<code>GERAR RELATÓRIO</code>',
                    },
                    content: '<code>Clique em <b>GERAR RELATÓRIO</b> para iniciar o processamento e avançar para a etapa visualização</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
            ],
        }
    },

    beforeCreate: function() {
		if (!this.$api.user.is_admin) {
			let permissions = this.$api.user.permissions.split(",");
			if (!permissions.includes("Report")) {
				this.$router.push({ name: 'Home' });
			}
		}
	},

    mounted: async function() {
        this.loading = true;
        this.$refs.tour.setTour();
        //await this.loadDocuments();
        await this.loadCargos();
        await this.loadDrivers();
        await this.loadVehicles();
        this.loading = false;
    },

    methods: {
        // Carrega as informações das filiais
        /*loadDocuments: async function() {
			let res = null;
			try {
				res = await Api.post("delivery/list-my-documents");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações da empresa e suas filiais.");
				return;
			}

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}
			this.my_documents = res.data;
		},*/
        
        loadCargos: async function() {
			let res = null;
			try {
				res = await Api.post("delivery/list-my-cargos");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações de cargas da empresa.");
				return;
			}

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}
			this.my_cargos = res.data;
		},

        // Carrega a lista de motoristas
		loadDrivers: async function() {
			let res = null;
			try {
				res = await Api.post("driver/list-my-drivers");
			} catch(ex) {
				console.log(ex);
				this.$notification.error("Não foi possível obter todas as informações necessárias.");
				return;
			}

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

            this.my_drivers = res.data;
		},
        
        // Carrega a lista de filiais
        loadVehicles: async function() {
            let res = null;

            try {
                res = await Api.post("vehicle/list-my-vehicles");
            } catch(ex) {
                console.log(ex);
                this.$notification.error("Não foi possível obter todas as informações necessárias.");
                return;
            }

			if (res.error) {
				this.$notification.error(res.data);
				return;
			}

            this.my_vehicles = res.data;
		},

        send: async function() {
            let form = this.$refs.report_form.validate();
            
            // Verifica o formado da validação
			if(form == null) {
				return;
            }
            
            // Requisita o salvamento
            this.loading = true;
            let result = null;
            
            // Requisita a API
            try {
                result = await Api.post("report/generate-report", form);
            } catch(ex) {
                console.log(ex);
                this.loading = false;
                this.$notification.error("Não foi possível processar o relatório. Por favor, tente novamente.");
            }
            
            // Verifica se houve resultado
            if(result != null) {
                //Verifica o resultado da requisição
                if(result.error) {
                    this.loading = false;
                    this.$notification.error(result.data);
                    return;
                }
                
                // Verifica se houve erro
                if (result.total  > 0) {
                    this.data = result.data;
                    this.loading = false;
                    
                    this.changeView("pdf");
                } else {
                    this.loading = false;
                    this.$notification.error("Não foram encontrados dados referente a essa filtragem. Por favor, tente novamente.");
                }
            }
        },

        // Voltar o modal
		back: function() {
            this.data = null;
			this.changeView("form");
		},

        // Muda a página atual
        changeView: function(value) {
            this.view = value;
        },
        
        // Atualiza o objeto de de dados
        updateFields: function(fields) {
            this.fields = fields;
        },

        download: function() {
            this.loading = true;
            this.$refs.report_view_pdf.download();
            this.loading = false;
        },

        setGenetating: function(value) {
            this.generating = value;
        },
    }
}
</script>

<style scoped>
.loading {
    background: #fff;
    color: #ddd;
    font-size: 80px;
    text-align: center;
    font-family: Verdana;
    z-index: 10;
    border: 1px solid #f0f0f0;
}

.inner-content-button {
	width: 100%;
	line-height: 30px;
	padding: 15px;
	background: #fff;
	font-weight: bold;
	border: 1px solid #f0f0f0;
	border-radius: 8px 8px 0 0;
}

.container-button {
    padding: 15px;
    border: 1px solid #f0f0f0;
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
    background-color: #fff;
}

.button-edit {
    padding: 10px 20px;
	font-size: 14px;
	font-weight: bold;
}

.button-back {
	background: #fff;
	border: 2px solid #222;
	color: #222;
	width: 120px;
	height: 30px;
	font-size: 12px;
	font-weight: bold;
}

.button-download {
	float: right;
	background: #0a600a;
	color: #fff;
	border: none;
	width: 120px;
	height: 30px;
	line-height: 25px;
	font-size: 12px;
	font-weight: bold;
}
</style>